<script>
	import { createEventDispatcher } from 'svelte'
	const dispatch = createEventDispatcher()
	import { dtunid } from '../functions/uid'
	import moment from 'moment'

	import TagInput from '../components/TagInput.svelte'

	import FullCalendar, { Draggable } from 'svelte-fullcalendar';
	import dayGridPlugin from '@fullcalendar/daygrid';
	import timeGridPlugin from '@fullcalendar/timegrid';
	import interactionPlugin from '@fullcalendar/interaction'; // needed for dateClick
	import frLocale from '@fullcalendar/core/locales/fr';
	import listPlugin from '@fullcalendar/list';
	export let events = [], idents, othersprops=[]
	
	let arridents = [],
		arrSelectedIdents = [],
		arrSelectedProps = []
	$:{
		if(idents){
			arridents = idents.map(t=>t.name)
		}
		/* if(othersprops) console.log("ENTRY othersprops",othersprops) */
	}
	let options = {
		locale: frLocale,
		weekNumbers: true,
		dateClick: handleDateClick,
		droppable: true,
		editable: true,
		events: [
			// initial event data
			
		],
		eventResize: function(info) {
			console.log(info.event)
		},
		eventClick: function(info) {
			console.log(info.event) // don't let the browser navigate
			let calendarApi = calendarComponentRef.getAPI()
			console.log(calendarApi.getEvents())
		},
		initialView: 'dayGridMonth',
		plugins: [dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin],
		headerToolbar: {
			left: 'prev,next today',
			center: 'title',
			right: 'dayGridMonth,timeGridWeek,timeGridDay,listMonth',
		},
		height: 'auto',
		weekends: true,
	},
	bdisplayEv = false,
	calendarComponentRef
/* 	eventData = { title: 'my event', duration: '02:00' }; */
	function toggleWeekends() {
		options.weekends = !options.weekends;
		options = { ...options };
	}
	function gotoPast() {
		let calendarApi = calendarComponentRef.getAPI();
		calendarApi.gotoDate('2000-01-01'); // call a method on the Calendar object
	}
	let editEvent = {},
		bNewEvent = false
	function handleDateClick(event) {
		let {
			id,
			groupId,
			allDay,
			dateStr,
			endStr,
			start,
			end,
			title,
			url,
			extendedProps
		} = event
		if(id===undefined){
			id = dtunid()
			bNewEvent = true
		} else {
			bNewEvent = false
		}
		editEvent = {
			id,
			groupId,
			allDay,
			dateStr,
			endStr,
			start,
			end,
			title,
			url,
			extendedProps
		}
		console.log(editEvent)
		bdisplayEv = true
			/* if (
				confirm('Would you like to add an event to ' + event.dateStr + ' ?')
			)  */
	}
	const changeEvent = (event) => {
		{
			const { events } = options;
			const calendarEvents = [
				...events,
				event,
			];
			options = {
				...options,
				events: calendarEvents,
			};
		}
	}

	const handlesubmit =(e) => {
		e.preventDefault()
		const 	form = e.target,
				title = form.querySelector("#title").value,
				allDay = form.querySelector("#allDay").checked,
				dateStr = (allDay)?form.querySelector("#dateStr").value:editEvent.allDay,
				start = (allDay)?editEvent.start: getTimeFromInputs(form.querySelector("#datestart").value,form.querySelector("#timestart").value), //https://stackoverflow.com/questions/63477650/moment-js-add-time-to-string-input
				end = (allDay)?editEvent.end: getTimeFromInputs(form.querySelector("#dateend").value,form.querySelector("#timeend").value),
				extendedProps = {...editEvent.extendedProps, idents: arrSelectedIdents, others:arrSelectedProps}
		editEvent = {...editEvent, allDay,
			dateStr,
			start,
			end,
			title,
			extendedProps
		}
		changeEvent(editEvent)
		dispatch("saveE", editEvent)
		bdisplayEv = false
	}

	const getTimeFromInputs = (elemDateValue, elemTimeValue) => {
		let date = (moment(elemDateValue).isValid())? moment(elemDateValue):moment(),
			time = (moment(elemTimeValue, 'HH:mm').isValid())?moment(elemTimeValue, 'HH:mm'): null
		return 	(time)?	date.format('YYYY-MM-DD') + ' '+time.format('HH:mm'): date.format('YYYY-MM-DD HH:mm:ss')
	}

	const handleChangeAllDayValue = (e) => {
		editEvent.allDay = e.target.checked
	}
	
	const handleListIdentChange = (e) => {
		arrSelectedIdents = e.detail
	}

	const handleListPropsChange = (e) => {
		arrSelectedProps = e.detail
		//console.log("arrSelectedProps",arrSelectedProps)
	}
</script>



<div class="demo-app">
	{#if bdisplayEv}
		<form on:submit={handlesubmit} class="form">
			{#if bNewEvent}
			<div class="ga flrsb"><h3>Nouvel événement</h3> <div class="muted">Réf: {editEvent.id}</div></div>
			{:else}
			<div class="ga flrsb"><h3>Édition de l'événement</h3> <div class="muted">Réf: {editEvent.id}</div></div>
			{/if}
			<label for="title" class="ga">Nom de l'événement</label>
			<input type="text" id="title" class="ga" required value={(editEvent.title!==undefined)?editEvent.title:""} placeholder="Entrez ici le titre de l'événement">
			<div class="checkboxes ga">
    			<label for="allDay"><span>Toute la journée</span> <input type="checkbox" id="allDay" checked={editEvent.allDay} on:change={handleChangeAllDayValue} /> </label>
			</div>
			{#if editEvent.allDay}
			<!-- svelte-ignore a11y-label-has-associated-control -->
			<label class="ga">Date</label>
			<input type="date" id="dateStr" class="gl" required value={(editEvent.dateStr)?moment(editEvent.dateStr).format('YYYY-MM-DD'):""}>
			{:else}
			<!-- svelte-ignore a11y-label-has-associated-control -->
			<label class="ga">Début</label>
			<input type="date" id="datestart" class="gl" required  value={(editEvent.dateStr)?moment(editEvent.dateStr).format('YYYY-MM-DD'):""}>
			<input type="time" id="timestart" class="gr">
			<!-- svelte-ignore a11y-label-has-associated-control -->
			<label class="ga">Fin</label>
			<input type="date" id="dateend" class="gl"  value={(editEvent.dateStr)?moment(editEvent.dateStr).format('YYYY-MM-DD'):""}>
			<input type="time" id="timeend" class="gr">
			{/if}
			<label for="name" class="ga">Participants de l'événement</label>
			<TagInput
				on:change={handleListIdentChange}
				listOptions={arridents}
				listsaved={arrSelectedIdents}
				className="ga"
			/>
			<div class="ga">Autres données</div>
			<TagInput
				on:change={handleListPropsChange}
				listOptions={othersprops}
				listsaved={arrSelectedProps}
				className="ga"
			/>
			<button class="ga" style="width:100%;">Enregistrer</button>
			<button class="ga" style="width:100%;" on:click|preventDefault={()=>{bdisplayEv = false}}>Annuler</button>
		</form>
	{/if}
<!-- 
	<div>
		<Draggable {eventData} class="draggable">
			Drag me in Week or Day view!
		</Draggable>
	</div>
 -->
	<div class="demo-app-calendar">
		<FullCalendar bind:this={calendarComponentRef} {options} />
	</div>
</div>

<style>
	.demo-app-calendar {
		box-sizing: border-box;
		margin: 1em auto;;
		max-width: 95vw; 
	}

	.checkboxes label {
		display: inline-block;
		padding-right: 10px;
		white-space: nowrap;
	}
	.checkboxes input {
		vertical-align: middle;
	}
	.checkboxes label span {
		vertical-align: middle;
	}
	.muted {
		font-size: .7em;
		color: #ccc;
		text-decoration: none!important;
	}
</style>